import { HelpIconTooltip } from "@components/common/help-icon-tooltip";
import { CircularProgress, TextField } from "@flat-ui";
import { Grid, InputAdornment } from "@mui-wrapper";

interface Props {
  /** Main label placed on top */
  label: string;

  /** The text */
  text: string;

  /** onChange handler for the text field */
  onChange: (text: string) => void;

  /** Whether something related is loading and a loading spinner on the right side of text field should be shown */
  isLoading?: boolean;

  /** Whether the textfield is disabled or not */
  isDisabled?: boolean;

  /** A text to show as a help icon tooltip */
  helpTooltip?: string | React.JSX.Element;

  /** A text showing below the text field */
  helpText?: string;

  /** Validation state - true if valid, or an object with validation error message */
  validation?: { isValid: true } | { isValid: false; message: string };
}

/** Shows a text field with label on top, a helper text on bottom and a help icon with tooltip on right */
export function RichTextField({
  label,
  text,
  onChange,
  isLoading = false,
  isDisabled,
  helpTooltip,
  validation = { isValid: true },
  helpText,
}: Props): React.JSX.Element {
  return (
    <Grid container sx={{ flexDirection: "column", mt: 2 }}>
      <TextField
        label={label}
        text={text}
        onTextChanged={onChange}
        fullWidth
        disabled={isDisabled || isLoading}
        error={validation.isValid === false && validation.message}
        endAdornment={
          helpTooltip && (
            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
              {isLoading ? (
                <CircularProgress size={15} />
              ) : (
                <HelpIconTooltip title={helpTooltip} />
              )}
            </InputAdornment>
          )
        }
        helpText={helpText}
      />
    </Grid>
  );
}
